import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { ProductClass } from '../../models/product-class.model';
import { ProductClassService } from '../../services/product-class.service';
import { ProductClassValidatorService } from '../../validators/product-class-validator.service';

@Component({
    selector: 'app-product-classes-edit',
    templateUrl: './product-classes-edit.component.html',
    styleUrls: ['./product-classes-edit.component.scss'],
    standalone: false
})
export class ProductClassesEditComponent implements OnInit {

  productClass: ProductClass = new ProductClass();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private productClassValidator: ProductClassValidatorService,
    private productClassService: ProductClassService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadProductClass(+params['id']);
    })
  }

  loadProductClass(id: number): void {
    this.productClassService.getProductClassById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((productClass: ProductClass) => {
      this.productClass = productClass;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.isSuccess = false;

    if (this.productClassValidator.isValid(this.productClass)) {
      this.productClassService.updateProductClass(this.productClass)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }
}
